export default __webpack_public_path__ + "static/media/roboto-latin-300italic.c64e7e35.woff2";